export function binnenBuitenSort(a, b) {
  if (a.name.startsWith("Binnen")) return -1000000;
  if (a.name.startsWith(">")) return 1000000;
  if (b.name.startsWith("Binnen")) return 1000000;
  if (b.name.startsWith(">")) return -1000000;
  return a.name.localeCompare(b.name);
}
